import React, { useState } from 'react'
import styles from './timothy.module.css'
import { Box, Link, Modal, Typography } from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";
import Head from 'next/head';
import MysteryBannerNew from '../../components/MysteryBannerNew/MysteryBannerNew';

export default function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [newOpen, setNewOpen] = useState(false);

  return (
    <>



      <Head>
        <title>School of Our Divine Infinite Being | Divine Theurgy, Astrology And Tarot</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Theurgy, Polytheistic Monism, Astrology School, Tarot School, Oracle Readings, Esoteric Education, Mystery School, Learn Astrology, Learn Tarot, Divine Infinite Being"
        ></meta>
        <meta
          property="og:title"
          content="School of Our Divine Infinite Being: Your Gateway to Theurgy, Astrology & Tarot"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/homepage_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="The logo and title for the School of Our Divine Infinite Being next to a swirling cosmic nebula, representing the school's esoteric and astrological teachings."
        ></meta>
        <meta
          property="og:description"
          content="Welcome to the School of Our Divine Infinite Being. Explore our comprehensive teachings on Divine Theurgy, Astrology, Tarot, and Polytheistic Monism. Join our courses to become a certified diviner."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/timothy-desmond"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/homepage_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="The logo and title for the School of Our Divine Infinite Being next to a swirling cosmic nebula, representing the school's esoteric and astrological teachings."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/timothy-desmond"
        ></meta>
        <meta
          name="twitter:title"
          content="School of Our Divine Infinite Being: Your Gateway to Theurgy, Astrology & Tarot"
        ></meta>
        <meta
          name="twitter:description"
          content="Welcome to the School of Our Divine Infinite Being. Explore our comprehensive teachings on Divine Theurgy, Astrology, Tarot, and Polytheistic Monism. Join our courses to become a certified diviner."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/timothy-desmond" />
      </Head>
      {/* <div className={styles.demo_img}>
        <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/timothy_desmond/imgpsh_fullsize_anim_new.webp'/>
       
    </div> */}

      <div className={styles.layman_bnnr_main_wrpr}>
        <div className={styles.ochema_ritual_blockone}>
          <div className={styles.ochema_ritual_banner_main_wrpr}>

            <div className={styles.ochema_ritual_banner_left}>
              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  <img src={`${process.env.cloud_url2}assets/images/viewicon.png`} />
                </span>
                <img src={`${process.env.cloud_url2}assets/images/logobanner.webp`} />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>
              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div className={`${styles.ochema_ritual_bottombannerbg} ${styles.bannerboxtxt}`}>
                <div className={styles.yellow_bar}></div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <MysteryBannerNew/>

      <div className={styles.timothy_block_main_wrpr}>
        <div className={styles.common_1width}>

          <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
            <div className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>TIMOTHY DESMOND</h1>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.common_width}>
          <div className={styles.block2_full_width}>
            <div className={styles.tarot_typology_box_wrpr2}>
              <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/timothy_desmond/timothy_book_1img_new_img.webp"
                      /> */}

                <img
                  className={styles.block2_part1_img}
                  src={`${process.env.cloud_url}our_teacher/timothy_desmond/timothy_book_1img_new_img.webp`}
                />
              </div>
              <div className={styles.tarot_typology_text_box}>
                <div className={styles.border_box}></div>
                <div className={styles.tarot_typology_text_box_bfr}>
                  <h6>ABOUT ME </h6>
                  <p>
                    Timothy Owen Desmond, who also goes by his acronym, Tod, was born in Bethesda, Maryland, in 1971. He attended Catholic schools until his last two years of high-school, after which he went back to a Catholic, Jesuit school, Boston College University, in 1989. During his first semester there, after being exposed to Plato and other great masters of Western philosophy and theology, he dropped out of the School of Management and enrolled in the College of Arts and Sciences so he could double-major in Philosophy and Political Science. He graduated in 1993. By his senior year he decided to dedicate his life to serving God by studying philosophy, with a focus on the
                    Krishna-worshipping, Gaudiya Vaishnava school of Vedanta, Plato, Nietzsche, Carl Jung, and the philosophical implications of quantum mechanics. Knowing that his unique interpretation of these topics would not likely harmonize with most graduate school philosophy programs, for the next thirteen years he studied and wrote independently. To support himself he worked at various jobs in Southern Maryland, Boston, and Washington, D.C., including tree-farm work, night-watchman duties, and clerical work near Capitol Hill.
                  </p>

                </div>
              </div>
            </div>
          </div>

          <div className={styles.block1_full_width}>
            <div className={styles.tarot_typology_box_wrpr}>
              <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/timothy_desmond/timothy_blk_2nd_img.webp"
                      /> */}
                <img
                  className={styles.block1_part1_img}
                  src={`${process.env.cloud_url}our_teacher/timothy_desmond/timothy_blk_2nd_img.webp`}
                />
              </div>
              <div className={styles.tarot_typology_text_box}>
                <div className={styles.border_box}></div>
                <div className={styles.tarot_typology_text_box_bfr}>


                  <p>
                    In 2006, after being advised by publishers that he was not likely to get published without a Ph.D., he went back to school. Continuing his tradition with Jesuit education, he earned a Master of
                    Liberal Studies degree from Georgetown University in 2008. After that, in 2009, he earned an M.A. in Political Science with a concentration in Alternative Futures Studies from the University of
                    Hawai’i in Manoa, where he focused on how to apply the philosophical implications of quantum mechanics to the Constitution. Finally, he earned a Ph.D. in Philosophy and Religion with a
                    concentration in Philosophy, Cosmology and Consciousness from the California Institute of
                    Integral Studies in 2014. It was while studying there that he discovered the parallels between
                    Leonard Susskind’s holographic string theory and Jungian psychology, which became the topic of his dissertation, and then his book, Psyche and Singularity: Jungian Psychology and Holographic String Theory, which was published in 2018. Most recently, in 2023, he published an online course based largely on his book, with additional material from Joseph Campbell and Ernest Becker, titled Immortality and the Unreality of Death: A Hero’s Journey through Philosophy, Psychology, and Physics.
                  </p>



                </div>
                <h3>I started studying philosophy and political science at Boston College in 1989, where I double-majored in those two subjects. I then earned a Master of Liberal Studies degree from Georgetown University, an MA in Political Science from the University of Hawai'i in Manoa, with a concentration in Alternative Futures
                  Studies, and a Ph.D. in Philosophy and Religion with a concent…</h3>
              </div>
            </div>
          </div>

          <div className={`${styles.block2_full_width} ${styles.sec2}`}>
            <div className={styles.tarot_typology_box_wrpr2}>
              <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/timothy_desmond/timothy_blk_3rd_img.webp"
                      /> */}

                <img
                  className={styles.block2_part1_img}
                  src={`${process.env.cloud_url}our_teacher/timothy_desmond/timothy_blk_3rd_img.webp`}
                />
              </div>
              <div className={styles.tarot_typology_text_box}>
                <div className={styles.border_box}></div>

                <div className={styles.tarot_typology_text_box_bfr}>
                  <h6>SOME MORE INFORMATION:</h6>
                  <p>
                    Tod Desmond is the Director of Administration at the Supporters of Agricultural Research (SoAR) Foundation. He also teaches philosophy and religion as an Adjunct Professor at The College of Southern Maryland.
                  </p>
                  <p>

                    He earned a BA in Philosophy and Political Science from Boston College; a Master of Liberal
                    Studies degree from Georgetown University; an MA in Political Science from the University of
                    Hawai’i in Manoa, with a concentration in Alternative Futures Studies; and a PhD in Philosophy and Religion from the California Institute of Integral Studies, with a specialization in Philosophy,
                    Cosmology, and Consciousness.
                  </p>
                  <div className={styles.timothy_blk2_flx_wrp}>
                    <div className={styles.timothy_blk2_flx_left}>
                      <Link href="https://www.amazon.com/Psyche-Singularity-Jungian-Psychology-Holographic-ebook/dp/B07HLWBZ1L/ref=sr_1_1?crid=11157TFUVXO81&keywords=psyche+and+singularity&qid=1654058703&sprefix=psyche+%2Caps%2C350&sr=8-1" target="_blank" >
                        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/timothy_desmond/amazon_text.webp'/> */}
                        <img src={`${process.env.cloud_url}our_teacher/timothy_desmond/amazon_text.webp`} />
                      </Link>
                    </div>
                    <div className={styles.timothy_blk2_flx_right}>
                      <Link href="https://www.amazon.com/Psyche-Singularity-Jungian-Psychology-Holographic-ebook/dp/B07HLWBZ1L/ref=sr_1_1?crid=11157TFUVXO81&keywords=psyche+and+singularity&qid=1654058703&sprefix=psyche+%2Caps%2C350&sr=8-1" target="_blank" >
                        <button> Get Psyche and Singularity</button></Link>
                    </div>

                  </div>





                </div>
              </div>
            </div>
          </div>
        </div>



      </div>




      {/* <div className={styles.demo_img}>
        <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/timothy_desmond/timothy_page_blk_img.webp' />
        <Link href="https://www.amazon.com/Psyche-Singularity-Jungian-Psychology-Holographic-ebook/dp/B07HLWBZ1L/ref=sr_1_1?crid=11157TFUVXO81&keywords=psyche+and+singularity&qid=1654058703&sprefix=psyche+%2Caps%2C350&sr=8-1" target="_blank" className={styles.blank_link}></Link>
        <Link href="https://www.amazon.com/Psyche-Singularity-Jungian-Psychology-Holographic-ebook/dp/B07HLWBZ1L/ref=sr_1_1?crid=11157TFUVXO81&keywords=psyche+and+singularity&qid=1654058703&sprefix=psyche+%2Caps%2C350&sr=8-1" target="_blank" className={styles.blank_2link}></Link>
      </div> */}


      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>
    </>
  )
}
